import { Card, CardProps, makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    roundedCard: {
        borderRadius: '12px',
    }
});

/**
 * Card component with enhanced border radius for more rounded appearance.
 *
 * This is a styled wrapper around Fluent UI's Card component that applies
 * custom border radius (12px instead of default 4px) for a more modern look.
 *
 * @example
 * ```tsx
 * <RoundedCard>
 *   <CardHeader>Title</CardHeader>
 *   <CardPreview>Preview content</CardPreview>
 * </RoundedCard>
 * ```
 */
export function RoundedCard(props: CardProps) {
    const styles = useStyles();

    return (
        <Card
            {...props}
            className={`${styles.roundedCard} ${props.className || ''}`}
        />
    );
}
